var render = function render(){var _vm=this,_c=_vm._self._c;return _c('samp',[_vm._v("距结束："+_vm._s(_vm.minuteVal))])
}
var staticRenderFns = []

export { render, staticRenderFns }